<phx-tile
  class="phx-radio-custom-tile"
  [phxClickable]="isRadioButton || isRadioTile"
  [phxSelected]="(isRadioButton || isRadioTile) && isChecked"
  [phxBorder]="isRadioButton || isRadioTile"
  [phxBackground]="phxBackground"
  [phxRemoveInlinePadding]="isRadio || isRadioButton"
  [phxDisabled]="phxDisabled || isListDisabled"
  [phxIsUsedAsSelector]="isRadioButton"
  [phxSize]="size"
  [phxTabIndex]="-2"
  [phxBackgroundStates]="true"
  (phxClick)="onHostClick($event)"
  (keydown)="handleKeyDown($event)"
>
  <span *ngIf="showPrefix" [class.phx-radio-tile-prefix]="!!(phxIcon || phxPrefixTemplate)" phx-tile-prefix>
    <ng-container *ngIf="phxPrefixTemplate; else radioOrIcon">
      <ng-container *ngTemplateOutlet="phxPrefixTemplate"></ng-container>
    </ng-container>
    <ng-template #radioOrIcon>
      <ng-container *ngIf="isRadio || phxTileType === 'radio'; else phxCustomIcon">
        <input type="radio" [disabled]="phxDisabled" [checked]="isChecked" [value]="phxValue" [attr.name]="phxValue" />
        <span #radioIcon class="phx-radio-icon" [attr.tabindex]="phxDisabled ? null : -2"></span>
      </ng-container>
      <ng-template #phxCustomIcon>
        <i phx-icon [phxIcon]="phxIcon" color="currentColor"></i>
      </ng-template>
    </ng-template>
  </span>
  <div [ngClass]="{ 'phx-radio-button-content': isRadioButton, 'phx-radio-content': isRadio }">
    <ng-content></ng-content>
  </div>
  <span *ngIf="showSuffix" class="phx-radio-tile-suffix" phx-tile-suffix>
    <ng-container *ngTemplateOutlet="phxSuffixTemplate"></ng-container>
  </span>
</phx-tile>
